import { render, staticRenderFns } from "./FieldSearchArticle.vue?vue&type=template&id=01404c30&"
import script from "./FieldSearchArticle.vue?vue&type=script&lang=js&"
export * from "./FieldSearchArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports